import { orderBy } from 'lodash';
import { useQuery } from 'react-query';

import { getStoredXerFileVersions as queryFn } from 'api/endPoints/getStoredXerFileVersions';

export const useQueryGetProjectVersionsList = (params) => {
    return useQuery<IVersion[], QueryError>(['useQueryGetProjectVersionsList', params], () => queryFn(params), {
        enabled: Boolean(params.projectId && params.contractId),
        cacheTime: 0,
        placeholderData: [],
        select: (response) => {
            return orderBy(response, ['versionDate'], ['desc']).filter((i) => i.status === 'OK');
        },
    });
};

//TODO create normal interface like all other queries. also consider separate to 2 different files
export interface IVersion {
    contractId: number;
    contractName: string;
    fileType: string;
    id: number;
    isBaseline: boolean;
    isDesignatedBaseline: boolean;
    isLatest: boolean;
    lastRefreshDate: number | null;
    maxLevel: number;
    projectId: number;
    projectName: string;
    projectType: string;
    sourceFile: string;
    status: string;
    tags: string[];
    uploadedDate: number;
    uploadingUser: string;
    versionDate: number;
    versionHashCode: number;
    versionId: number;
    versionName: string;
}
